export function carrotquestId() {
  const cookieValue = document.cookie.split("; ").find((row) => row.startsWith("carrotquest_uid="))
  const carrotquest_uid = cookieValue ? cookieValue.split("=")[1] : null

  return carrotquest_uid
}
